import { docsLink, slackLink, statusLink, githubLink } from "constants/Links";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { ROUTES } from "routes/constants";
import {
  faCrown,
  faBookOpen,
  faUserGroup,
  faServer,
  faHardDrive,
  faClock,
  faMicrochip,
  faBox,
} from "@fortawesome/pro-regular-svg-icons";
import { faCode } from "@fortawesome/pro-duotone-svg-icons";

export interface MenuItemType {
  name: string;
  link: string;
  description?: string;
  icon: IconProp; // Using direct imports from @fortawesome/pro-regular-svg-icons
}

export interface NavItemType {
  name: string;
  link?: string;
  isMenu?: boolean;
  menuItems?: MenuItemType[];
  featuredArticle?: {
    slug?: string;
  };
}

// Define a new "Resources" submenu items
export const resourcesMenuItems: MenuItemType[] = [
  {
    name: "Customers",
    link: ROUTES.customers,
    description: "Learn how teams build and scale their AI apps with Beam.",
    icon: faCrown,
  },
  {
    name: "Blog",
    link: ROUTES.blog,
    description: "Stay ahead with technical tutorials and product updates.",
    icon: faBookOpen,
  },
  {
    name: "Join Slack Community",
    link: slackLink,
    description: "Ask questions, get help, and connect with other developers in our community.",
    icon: faUserGroup,
  },
  {
    name: "About",
    link: ROUTES.about,
    description: "We’re more than a cloud provider—learn about our mission.",
    icon: faCode,
  },
];

export const productMenuItems: MenuItemType[] = [
  {
    name: "Inference",
    link: "https://docs.beam.cloud/v2/endpoint/overview",
    description: "Deploy high-performance inference endpoints.",
    icon: faMicrochip,
  },
  {
    name: "Task Queues",
    link: "https://docs.beam.cloud/v2/task-queue/running-tasks",
    description: "Run task queues for large-scale workloads.",
    icon: faServer,
  },
  {
    name: "Sandboxes",
    link: "https://docs.beam.cloud/v2/sandbox/overview",
    description: "Run anything in secure code execution environments.",
    icon: faBox,
  },
  {
    name: "Containers",
    link: "https://docs.beam.cloud/v2/pod/web-service",
    description: "Host arbitrary containers as cloud services.",
    icon: faCode,
  },
  {
    name: "Storage Volumes",
    link: "https://docs.beam.cloud/v2/data/volume",
    description: "Store large files in distributed storage volumes.",
    icon: faHardDrive,
  },
  {
    name: "Scheduled Jobs",
    link: "https://docs.beam.cloud/v2/function/scheduled-job",
    description: "Run cloud functions on a schedule.",
    icon: faClock,
  },
];

const NavItems: NavItemType[] = [
  {
    name: "Product",
    isMenu: true,
    menuItems: productMenuItems,
  },
  {
    name: "Resources",
    isMenu: true,
    menuItems: resourcesMenuItems,
    featuredArticle: {
      slug: "geospy-case-study",
    },
  },
  {
    name: "Customers",
    link: ROUTES.customers,
  },
  {
    name: "Pricing",
    link: ROUTES.pricing,
  },
  {
    name: "Documentation",
    link: docsLink,
  },
];

export default NavItems;
